// @flow
import * as React from 'react';
import { injectIntl, defineMessages, type IntlShape } from 'react-intl';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import type { ValueType } from 'react-select/src/types';
import FieldWrapper from './FieldWrapper';


type Props = {
    field: {
        value: any;
        name: string;
    },
    required: boolean,
    label: string,
    help_text: string,
    form: {
        setFieldValue: (string, any, ?boolean) => void,
        isSubmitting: boolean,
    },
    locale: string,
    intl: IntlShape,
}

const messages = defineMessages({
    required: {
        id: 'recaptcha-required',
        defaultMessage: 'This field is required.',
    },
});

class RecaptchaInput extends React.Component<Props> {
    input: { current: ReCAPTCHA };

    static getValidationSchema(field: { validation: Object }) {
        let errMsg = Yup.string().nullable();
        if (field.validation.required) {
            errMsg = Yup.string().required(messages.required).nullable();
        }

        return errMsg;
    }

    constructor(props: Props) {
        super(props);
        this.input = React.createRef();
    }

    componentDidUpdate(prevProps: Props) {
        const { form: { isSubmitting, setFieldValue }, field: { name } } = this.props;
        const { form: { isSubmitting: isSubmittingPrev } } = prevProps;
        if (!isSubmitting && isSubmitting !== isSubmittingPrev) {
            this.input.current.reset();
            setFieldValue(name, null, false);
        }
    }

    handleChange = (value: ValueType) => {
        const { form: { setFieldValue }, field: { name } } = this.props;
        setFieldValue(name, value);
    };

    render() {
        const {
            field: {
                name,
            },
            label,
            help_text: help,
            required,
        } = this.props;

        return (
            <FieldWrapper
                name={name}
                required={required}
                helpText={help}
                label={label}
            >
                <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={this.handleChange}
                    ref={this.input}
                    hl={this.props.intl.locale}
                />
            </FieldWrapper>
        );
    }
}


export default injectIntl(RecaptchaInput);
